var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_4794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_4794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5471 27.7445V26.1678C28.5471 22.4359 25.5107 19.4272 21.7771 19.4272H8.22261C4.47443 19.4272 1.45264 22.4504 1.45264 26.1678V27.7445",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7773 8.68713C21.7773 12.4191 18.7409 15.4277 15.0073 15.4277C11.2736 15.4277 8.2373 12.4046 8.2373 8.68713C8.2373 4.96968 11.2591 1.94653 15.0073 1.94653C18.7555 1.94653 21.7773 4.96968 21.7773 8.68713Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_4794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_4794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserB);
export default __webpack_public_path__ + "static/media/userB.4c55fd7084fe2b9d4425edcd507fb0d0.svg";
export { ForwardRef as ReactComponent };